import React, { useState } from 'react';
import { Link } from 'react-router-dom';  // Import Link komponenta
import './Header.css';

const Header = () => {
    const [menuOpen, setMenuOpen] = useState(false);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    // Funkcija za zatvaranje menija nakon što je opcija odabrana
    const closeMenu = () => {
        setMenuOpen(false);
    };

    return (
        <header className="header">
            <div className="logo">
                {/* Oko slike dodajte Link komponentu */}
                <Link to="/" onClick={closeMenu}>
                    <img 
                        src="/images/logo.png" 
                        alt="TooRistico" 
                        style={{ height: "60px" }}
                    />
                </Link>
            </div>
            <nav className={`nav ${menuOpen ? 'open' : ''}`}>
                {/* Linkovi za navigaciju sa funkcijom koja zatvara meni */}
                <Link to="/" onClick={closeMenu}>Home</Link> {/* Link za početnu stranicu */}
                <Link to="/our-offer" className="nav-link" onClick={closeMenu}>Our offer</Link>  {/* Link za "Our Offer" */}
                <Link to="/contact" className="nav-link" onClick={closeMenu}>Contact</Link>  {/* Link za "Contact" */}
                
                {/* Logo unutar mobilnog menija */}
                {menuOpen && (
                    <div className="mobile-logo">
                        <img 
                            src="/images/TooRisticoSmall.png" 
                            alt="TooRistico" 
                            style={{ height: "60px" }}
                        />
                    </div>
                )}
            </nav>
            {/* Hamburger ikonica */}
            <div className={`hamburger ${menuOpen ? 'open' : ''}`} onClick={toggleMenu}>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </header>
    );
};

export default Header;
